import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import successToast from '../../toasts/successToast';

const users = [
    { id: 1, name: 'user Alpha' },
    { id: 2, name: 'user Bravo' },
    { id: 3, name: 'user Charlie' },
];

const tasks = [
    { id: 1, task: 'Post Editing' },
    { id: 2, task: 'Review' },
];

const validationSchema = Yup.object().shape({
    user: Yup.string().required('Required'),
    task: Yup.string().required('Required'),
    comments: Yup.string().required('Required'),
});

const initialValues = {
    user: '',
    task: '',
    comments: '',
};

const AssignedUsers = ({ show, handleClose, title }) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                console.log('Form data', values);
                successToast('Success');
                handleClose();
            }}
        >
            {({ handleSubmit, isValid, dirty }) => (
                <Modal
                    show={show}
                    onHide={handleClose}
                    centered
                    style={{ margin: 'auto', minWidth: '75vh' }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormikForm>
                            <div className="mb-3">
                                <div className='d-flex'>
                                    <div className="text-start gap-2 mb-2 text-nowrap mx-3">
                                        <label htmlFor="user" className="py-1">User</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name="user"
                                                as="select"
                                                className="input-field"
                                                id="user"
                                                style={{ width: '10rem' }}
                                            >
                                                <option value="">Select a User</option>
                                                {users.map((user) => (
                                                    <option key={user.id} value={user.name}>
                                                        {user.name}
                                                    </option>
                                                ))}
                                            </Field>
                                        </div>
                                        <ErrorMessage name="user" component="div" className="text-danger mt-1 fs_12" />
                                    </div>
                                    <div className="text-start gap-2 mb-2 text-nowrap mx-3">
                                        <label htmlFor="task" className="py-1">Task</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name="task"
                                                as="select"
                                                className="input-field"
                                                id="task"
                                                style={{ width: '10rem' }}
                                            >
                                                <option value="">Select a Task</option>
                                                {tasks.map((task) => (
                                                    <option key={task.id} value={task.task}>
                                                        {task.task}
                                                    </option>
                                                ))}
                                            </Field>
                                        </div>
                                        <ErrorMessage name="task" component="div" className="text-danger mt-1 fs_12" />
                                    </div>
                                </div>

                                <div className="text-start gap-2 mb-2 text-nowrap mx-3">
                                    <label htmlFor="comments" className="py-1">Comments</label>
                                    <div className="d-flex position-relative">
                                        <Field
                                            name="comments"
                                            as="textarea"
                                            className="input-field"
                                            id="comments"
                                            style={{ width: '22rem' }}
                                        />
                                    </div>
                                    <ErrorMessage
                                        name="comments" component="div" className="text-danger mt-1 fs_12"
                                    />
                                </div>
                            </div>
                        </FormikForm>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={!(isValid && dirty)}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </Formik>
    );
};

export default AssignedUsers;
